/* @flow */

import * as React from 'react'
import styled from 'styled-components'
import { withRouter } from 'react-router-dom'

import { getDimensionValue } from '../shared'
import {
  WebshopGridItemBanner,
  WebshopGridItemBannerChildrenContainer,
  useWebshopGridItemBannerContentContainerStyle,
} from '../WebshopBanner'
import { WebshopContext } from '../../../shared'

const WebshopDropLinkWidget = ({ gridItem, history, ...rest }) => {
  const { shopUrl, updateWebshopSession } = React.useContext(WebshopContext)

  const contentContainerStyle =
    useWebshopGridItemBannerContentContainerStyle(gridItem)

  const onClick = React.useCallback(() => {
    const updatedSessionData = {
      drop_id: gridItem.data.drop_id || null,
      drop_filter_code: gridItem.data.drop_filter_code || null,
      subbrand_id: gridItem.data.subbrand_id || null,
    }

    return updateWebshopSession(updatedSessionData).then(response => {
      if (!response.error) {
        history.push(`${shopUrl}/landing`)
      }
    })
  }, [history, gridItem, shopUrl, updateWebshopSession])

  const heightValue = getDimensionValue(
    gridItem.data.height_mode,
    gridItem.data.fixed_height,
    null,
    gridItem.data.viewport_percentage_height
  )

  return (
    <StyledWebshopGridItemBanner
      bodyColor={gridItem.data.body_font_color}
      contentContainerStyle={contentContainerStyle}
      gridItem={gridItem}
      heightMode={gridItem.data.height_mode}
      heightValue={heightValue}
      imageOrVideo={gridItem.data.banner}
      onClick={onClick}
    >
      <WebshopGridItemBannerChildrenContainer gridItem={gridItem}>
        {gridItem.children.map(childGridItem => {
          const GridItemComponent = childGridItem.component

          if (!GridItemComponent) {
            return null
          }

          return <GridItemComponent gridItem={childGridItem} {...rest} />
        })}
      </WebshopGridItemBannerChildrenContainer>
    </StyledWebshopGridItemBanner>
  )
}

export default withRouter(WebshopDropLinkWidget)

const StyledWebshopGridItemBanner = styled(WebshopGridItemBanner)`
  cursor: pointer;
`
